import { Box, FormHelperText } from '@mui/material';

import { Text } from 'common';

export function AgentConversationFormFields() {
  return (
    <Box>
      <Text>No configuration required</Text>
      <FormHelperText>
        Extract agent conversations for patient or encounter from Notable databases.
      </FormHelperText>
    </Box>
  );
}
